import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import StyledInput from "../../UI/StyledInput";
import ReactLoading from "react-loading";
import { useState } from "react";
import { directus } from "../../../Api/FetchDirectus";
import { createItem, registerUser } from "@directus/sdk";
import { useNavigate } from "react-router-dom";
import StyledPassword from "../../UI/StyledPassword";

const Registration = ({ close, login }: TestFormInterface) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [loader, setLoader] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const [passwordStatus, setPasswordStatus] = useState(false);
  const [passwordRepeatStatus, setPasswordRepeatStatus] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function validatePassword(password: string) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

    if (passwordRegex.test(password)) {
      return true;
    } else {
      return false;
    }
  }

  function onClose() {
    close(false);
  }

  function onChange(e: any, type: string) {
    if (type === "email") {
      setEmail(e.target.value);
    }

    if (type === "password") {
      setPassword(e.target.value);
    }

    if (type === "password_repeat") {
      setPasswordRepeat(e.target.value);
    }
  }

  async function goTest() {
    setLoader(true);
    if (email.trim() === "" || !validateEmail(email)) {
      setEmailStatus(true);
    } else {
      setEmailStatus(false);
    }

    if (password.trim() === "" || !validatePassword(password)) {
      setPasswordStatus(true);
    } else {
      setPasswordStatus(false);
    }

    if (passwordRepeat.trim() === "" || password !== passwordRepeat) {
      setPasswordRepeatStatus(true);
    } else {
      setPasswordRepeatStatus(false);
    }

    if (
      validateEmail(email) &&
      validatePassword(password) &&
      password === passwordRepeat
    ) {
      let result;
      try {
        result = await directus.request(registerUser(email, password));
        alert(
          "Для завершения регистрации перейдите по ссылке в письме, отправленном на указанную электронную почту"
        );
        close(false);

        const age = localStorage.getItem("age");
        const gender = localStorage.getItem("gender");
        const activity = localStorage.getItem("activity");
        const position = localStorage.getItem("position");

        try {
          await directus.request(
            createItem("Course_History", {
              email: email,
              form: JSON.stringify({
                age: age,
                gender: gender,
                activity: activity,
                position: position,
              }),
              date: JSON.stringify(new Date()),
            })
          );
          window.scrollTo(0, 0);
          navigate("/modules");
        } catch (error: any) {
          sessionStorage.removeItem("token");
          navigate("/");
        }
        navigate("/course");
        return result;
      } catch (error: any) {
        setErrorStatus(true);
        setErrorText("Возникла ошибка");
        sessionStorage.removeItem("token");
        return;
      }
    }

    setLoader(false);
  }

  return (
    <div className="popUp">
      <div className="popTestForm">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>
        <h2>Регистрация</h2>
        {errorStatus ? <div className="errorText">{errorText}</div> : null}
        {emailStatus && !validateEmail(email) ? (
          <div className="errorText">Почта введена неверно</div>
        ) : null}
        <StyledInput
          text="Электронная почта"
          placeholder="Укажите вашу электронную почту"
          className={emailStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "email")}
        />

        {passwordStatus && !validatePassword(password) ? (
          <div className="errorText">
            Пароль должен быть не меньше 8 символов, содержать большие и
            маленькие буквы, и цифры
          </div>
        ) : null}
        <StyledPassword
          text="Пароль"
          placeholder="Укажите пароль"
          className={passwordStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "password")}
        />
        {passwordRepeatStatus && password !== passwordRepeat ? (
          <div className="errorText">Пароли должны совпадать</div>
        ) : null}
        <StyledPassword
          text="Повторите пароль"
          placeholder="Укажите пароль ещё раз"
          className={passwordRepeatStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "password_repeat")}
        />
        <div className="testFormStartBox">
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              onClick={() => goTest()}
              className="blueButton testFormButton"
              text="ЗАРЕГИСТРИРОВАТЬСЯ"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Registration;
